import styled from 'styled-components';
import { breakpoint } from '../theme/breakpoint';
import DonationFormHandler from '../donation-form-handler';
import { ContentSemi } from '../styled/containers';
import { multiplyPx } from '../styled/utils';

const halfPx = multiplyPx(0.5);

export const Banner = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  border-top: ${({ theme, $borderTop }) =>
    $borderTop && `1px solid ${theme.palette.border}`};
  padding: ${({ theme }) => `${theme.spacing.xlarge} 0`};

  ${breakpoint.tablet`
    margin-bottom: ${({ $removeMarginBottom, theme }) =>
      $removeMarginBottom ? '0' : theme.spacing.xlarge};
  `};
`;

export const Wrapper = styled.section`
  color: ${({ theme }) => theme.palette.standardText};
  display: flex;
  flex-wrap: wrap;

  ${breakpoint.tablet`
    flex-wrap: nowrap;

    > ${ContentSemi} + ${ContentSemi} {
      margin-left: ${({ theme }) => theme.spacing.standard};
    }
  `};
`;

export const Header = styled.h3`
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.tiny};

  ${breakpoint.tablet`
    margin-bottom: 0;
  `};
`;

export const SubText = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

export const StyledDonationFormHandler = styled(DonationFormHandler)`
  > div {
    border-width: 2px;
    width: 100%;
    max-width: 164px;
    margin-right: ${({ theme }) => halfPx(theme.spacing.tiny)};
  }
`;
